'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Select;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./select.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Select Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function Select(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        id = props.id,
        _props$isDisabled = props.isDisabled,
        isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled,
        onChange = props.onChange,
        name = props.name,
        children = props.children,
        value = props.value;


    return (0, _jsx3.default)('select', {
        id: id,
        onChange: onChange,
        disabled: isDisabled,
        className: className,
        name: name,
        value: value
    }, void 0, children);
}
// css
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/select/Select.js
// module id = 600
// module chunks = 0